import service from '@/utils/requestAdmin';
import axios from 'axios';
import API from '@/config/api';



export async function getNewsListUser() {

  return service(
    {
      url:'/product/getnewsList',
      method:'get',
    })
}

export async function getTopNewsUser() {

  return service(
    {
      url:'/product/gettopnewsList',
      method:'get',
    })
}

export async function getNewsDetileUser(newsSn) {

  // return service(
  //   {
  //     url:`/product/getNew?newsSn=${newsSn}`,
  //     method:'get',
  //   })

  try {
    const response = await axios({
      method: 'get',
      url: API.NEWS_DETAIL(newsSn), // 获取商品信息
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data; // 返回后端的响应数据
  } catch (error) 
  {
    console.error('产品目录树获取出错:', error);
    throw error; // 抛出错误以供调用处捕获
  }
}